import { Buffer } from './Buffer';
var Type = /** @class */ (function () {
    function Type() {
    }
    Type.prototype.encode = function (value) {
        var buffer = new Buffer();
        this.encodeBuffer(value, buffer);
        return buffer.getValue();
    };
    Type.prototype.decode = function (data) {
        return this.decodeBuffer(new Buffer(data));
    };
    return Type;
}());
export { Type };
